import styled from 'styled-components'

export const Card = styled.section`
  width: min(760px, 100%);
  margin: 0 auto;
  padding: 32px;
  border: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-radius: 18px;
  background: ${p => p.theme.palette.colors.surfaceElevated};
  box-shadow: 0 18px 42px ${p => p.theme.palette.colors.shadowStrong};

  @media(max-width: 640px) {
    padding: 22px;
  }
`

export const Eyebrow = styled.div`
  color: ${p => p.theme.palette.blue.main};
  font-family: Poppins;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
`

export const Title = styled.h1`
  margin: 8px 0;
  color: ${p => p.theme.palette.colors.text};
  font-family: Gilroy;
  font-size: 34px;
  line-height: 1.15;

  @media(max-width: 640px) {
    font-size: 29px;
  }
`

export const Description = styled.p`
  margin: 0 0 26px;
  color: ${p => p.theme.palette.colors.muted};
  font-family: Lato;
  font-size: 16px;
  line-height: 1.6;
`

export const EmptyText = styled.p`
  color: ${p => p.theme.palette.colors.muted};
`

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 520px) {
    & > * {
      width: 100%;
    }
  }
`
